import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const DeviceContext = createContext()

const DeviceProvider = ({ children }) => {

    const { headers, toast, restaurantId } = useAuth();

    const getAllDevices = async (currentPage, rowsPerPage, sortField, sortOrder) => {
        try {
            const { data } = await axios.get(`${baseURL}/device/list?sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&restaurant_id=${restaurantId}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Device', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const getSingleDevice = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/device/single-device/${id}`, { headers })
            if (data.error === false) {
                return data.data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Device', detail: data?.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Device', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const createDevice = async (deviceDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/device/create`, deviceDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Device', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Device', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Device', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Device', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Device', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const updateDevice = async (id, deviceDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/device/update/${id}`, deviceDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Device', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Device', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Device', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Device', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Device', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const deleteDevice = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/device/delete/${id}`, { headers });
            if (data.error === false) {
                toast.current.show({ severity: 'success', summary: 'Device', detail: data.message, life: 3000 })
            } else {
                toast.current?.show({ severity: 'error', summary: 'Device', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Device', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <DeviceContext.Provider value={{ getAllDevices, getSingleDevice, createDevice, updateDevice, deleteDevice }}>
            {children}
        </DeviceContext.Provider>
    )
}

const useDevice = () => useContext(DeviceContext)

export { useDevice, DeviceProvider }